import React from 'react';
import { hasElements } from '../../utils';
import { Input } from '../Input';
import { Fieldset } from '../Fieldset';

export function CaivrsTab({ Guarantors, Borrowers, updateObjectInArray }) {
  return (
    <>
      {!hasElements([...Guarantors, ...Borrowers]) && (
        <div className="text-center">
          <strong>No guarantors/borrowers defined</strong>
        </div>
      )}

      {[...Guarantors, ...Borrowers].map((object) => {
        const { id, ObjectType, Name } = object;

        return (
          <Fieldset
            className="mb"
            key={id}
            id={id}
            legend={ObjectType}
            hasComments={true}
            timestamp={object?.Caivrs?.Timestamp}
            comments={object?.Caivrs?.Comments}
            onCommentsChange={(value) =>
              updateObjectInArray('Objects', id, 'Caivrs.Comments', value)
            }
            onTimestampChange={(value) =>
              updateObjectInArray('Objects', id, 'Caivrs.Timestamp', value)
            }
          >
            <div className="mb--sm form-group-inline">
              <label htmlFor={`name-${id}`}>Name</label>
              <Input
                className="input-longer borderless backgroundless font-semibold"
                id={`name-${id}`}
                readOnly
                value={Name}
              />
            </div>

            <div className="mb--sm form-group-inline">
              <label htmlFor={`authorization-number-${id}`}>Authorization Number</label>
              <Input
                id={`authorization-number-${id}`}
                type="text"
                value={object?.Caivrs?.AuthorizationNumber}
                onChange={(event) =>
                  updateObjectInArray(
                    'Objects',
                    id,
                    'Caivrs.AuthorizationNumber',
                    event.target.value
                  )
                }
              />
            </div>

            <div className="form-group-inline">
              <label>
                <Input
                  id={`not-found-${id}`}
                  type="checkbox"
                  checked={!!object?.Caivrs?.NotFound}
                  onChange={(event) =>
                    updateObjectInArray('Objects', id, 'Caivrs.NotFound', event.target.checked)
                  }
                />{' '}
                No Cases Found in CAIVRS
              </label>
            </div>
          </Fieldset>
        );
      })}
    </>
  );
}
